import { render, staticRenderFns } from "./InvoiceofTransaction.vue?vue&type=template&id=4839af27"
import script from "./InvoiceofTransaction.vue?vue&type=script&lang=js"
export * from "./InvoiceofTransaction.vue?vue&type=script&lang=js"
import style0 from "./InvoiceofTransaction.vue?vue&type=style&index=0&id=4839af27&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports